import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { CustomPropTypeDescriptor, CustomPropValueWithReference } from './model/customprop.type';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class CustomPropTypeService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'CustomPropTypeManagement',
      authService,
      config.CPMSConfig
    );
  }

  public create(customPropType: CustomPropTypeDescriptor): Promise<CustomPropTypeDescriptor> {
    return super.post<CustomPropTypeDescriptor>(
      new CustomPropTypeDescriptor({
        id: undefined,
        href: undefined,
        name: customPropType.name,
        description: customPropType.description,
        objectType: customPropType.objectType,
        inputType: customPropType.inputType,
        argument: customPropType.argument,
        usage: customPropType.usage,
        reason: customPropType.reason,
        modified: customPropType.modified,
        deleted: customPropType.deleted
      }));
  }
  
  public update(id: string, role: CustomPropTypeDescriptor): Promise<CustomPropTypeDescriptor> {
    return super.put<CustomPropTypeDescriptor>(id, role);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  async GetList(v: View): Promise<List<CustomPropTypeDescriptor>> {
    return await this.getCustomPropTypes(v);
  }

  public getCustomPropTypes(view?: View): Promise<List<CustomPropTypeDescriptor>> {
    return super.get<List<CustomPropTypeDescriptor>>(undefined, view);
  }

  async GetById(id: string): Promise<CustomPropTypeDescriptor> {
    return await this.getById(id);
  }

  async GetValues(id: string): Promise<CustomPropValueWithReference[]> {
    return super.get<CustomPropValueWithReference[]>(id,undefined,'values');
  }

  public getById(id: string): Promise<CustomPropTypeDescriptor> {
    return super.get<CustomPropTypeDescriptor>(id);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }

  static customPropTypeCache: any = {};

  public async GetCustomPropertyByName(name: string, type: string): Promise<CustomPropTypeDescriptor | undefined> {
     var key = `${type}:${name}`;
     var v = CustomPropTypeService.customPropTypeCache[key];
     if (!v) {
      var view = new View();

      view.addFilter("Name",name);
      view.addFilter("RelatedObjectType",type);

      var cpts = await this.getCustomPropTypes(view);
      if (cpts && cpts.value && cpts.value.length) {
        v = cpts.value[0];
        CustomPropTypeService.customPropTypeCache[key] = v;
      } 
    }

    return v;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/customprop.type/customprop.type.service.ts